var render = function () {
  var _vm$lecture, _vm$lecture2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', [_c('v-layout', {
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('v-icon', {
    staticClass: "mb-10 mb-lg-20 primary--text",
    attrs: {
      "size": "80"
    }
  }, [_vm._v("mdi-close-octagon-outline")]), _c('v-sheet', {
    staticClass: "text-center mb-20 mb-lg-40"
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm._v("접근 불가")]), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [!!((_vm$lecture = _vm.lecture) !== null && _vm$lecture !== void 0 && _vm$lecture.subject) ? [_vm._v(" \"" + _vm._s((_vm$lecture2 = _vm.lecture) === null || _vm$lecture2 === void 0 ? void 0 : _vm$lecture2.subject) + "\" ")] : [_vm._v(" 해당")], _vm._v(" 교육 서비스에 대한 접근이 불가능합니다. ")], 2)]), _c('div', {
    staticClass: "v-btn-group mt-0"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', [_vm._v("뒤로가기")])])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }